import React from "react";
import { Spinner } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { PATH } from "../../config";
export function Loader({ customClass,spinnerVariant }) {
  return (
    <div className={`text-align-center marginfromtop ${customClass}`}>
      <Spinner
        animation="border"
        className="margin-auto"
        variant={spinnerVariant || "info"}
        role="status"
      />
    </div>
  );
}

export function DynamicLoad() {
  let history = useHistory();
  const { type } = useParams();
  return (
    <div
      id="my-loader"
      className={`loader-center ${
        history.location.pathname !== PATH.FINANCE_DASHBOARD &&
        history.location.pathname !== PATH.TEAMSCHEDULER &&
        history.location.pathname !== PATH.DASHBOARD.replace(":type", type) &&
        history.location.pathname !== PATH.LOGIN &&
        history.location.pathname !== PATH.HOMEPAGE &&
        history.location.pathname !== PATH.WORKLOAD &&
        history.location.pathname !== PATH.PROJECTS &&
        history.location.pathname !== PATH.KANBAN
          ? // ? "loader-center-width"
            ""
          : ""
      }`}
    >
      <Spinner
        animation="border"
        className="margin-auto"
        variant="info"
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </Spinner>
    </div>
  );
}
